import type { JSX } from 'react';
import { cx } from './styles';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  /**
   * 无障碍文案。不传则视为**纯装饰**（`aria-hidden`），由周围的文字负责说明
   * 在忙什么；只有"这圈转动的圈是页面上唯一能解释当前状态的东西"时才需要传它。
   */
  label?: string;
  className?: string;
}

const SIZES: Record<SpinnerSize, string> = {
  sm: 'size-3.5 border-2',
  md: 'size-5 border-2',
  lg: 'size-8 border-4',
};

/**
 * 忙碌指示（不确定进度）。确定进度请用 `ProgressBar`。
 */
export function Spinner({ size = 'md', label, className }: SpinnerProps): JSX.Element {
  return (
    <span
      {...(label === undefined ? { 'aria-hidden': true } : { role: 'status' })}
      className={cx(
        'inline-block shrink-0 animate-spin rounded-full border-line border-t-accent motion-reduce:animate-none',
        SIZES[size],
        className,
      )}
    >
      {label === undefined ? null : <span className="sr-only">{label}</span>}
    </span>
  );
}
